import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { getProjectsBasePath, getCohortsPath } from '@verantos-dev/core-constants';
import { type PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

import { useTriggerExitModal } from './useTriggerExitModal';
import { useResetCohortBuilderState } from '../../../../../hooks/common/useResetCohortBuilderState';

export const useCohortBuilderPageBreadcrumbs = (projectName: string, cohortName: string) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { projectId } = useParams();
  const { onTriggerExitModal } = useTriggerExitModal();
  const { resetCohortBuilderState } = useResetCohortBuilderState();

  const breadcrumbs: PageHeaderBreadcrumb[] = [
    {
      label: intl.formatMessage({
        id: 'projects.cohortBuilderPage.breadcrumbs.projects',
      }),
      onClick: () =>
        onTriggerExitModal(() => {
          navigate(getProjectsBasePath());
          resetCohortBuilderState();
        }),
    },
    {
      label: projectName,
      onClick: () =>
        onTriggerExitModal(() => {
          projectId ? navigate(getCohortsPath(projectId)) : navigate(getProjectsBasePath());
          resetCohortBuilderState();
        }),
    },
    {
      label: intl.formatMessage({ id: 'projects.cohortBuilderPage.breadcrumbs.cohorts' }),
      onClick: () =>
        onTriggerExitModal(() => {
          projectId ? navigate(getCohortsPath(projectId)) : navigate(getProjectsBasePath());
          resetCohortBuilderState();
        }),
    },
    { label: cohortName },
  ];

  return breadcrumbs;
};
